/**
 * @generated SignedSource<<48e01aa01291f7324d881d70a8a10e33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_item$data = {
  readonly productPhotos: ReadonlyArray<{
    readonly smallPath: string | null;
    readonly versions: ReadonlyArray<{
      readonly webPath: string | null;
    } | null> | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_item" | "FavoritesItemProvider_item" | "ItemTileCarousel_item" | "SharedFavoriteItem_item">;
  readonly " $fragmentType": "SharedItemTile_item";
};
export type SharedItemTile_item$key = {
  readonly " $data"?: SharedItemTile_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "fetchVideo",
    "variableName": "fetchVideo"
  },
  {
    "kind": "Variable",
    "name": "isTrade",
    "variableName": "isTrade"
  },
  {
    "kind": "Variable",
    "name": "pageDisplayEnum",
    "variableName": "pageDisplayEnum"
  },
  {
    "kind": "Variable",
    "name": "priceBookName",
    "variableName": "priceBookName"
  },
  {
    "kind": "Variable",
    "name": "showSeller",
    "variableName": "showSeller"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchVideo"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_item",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "BuyerProductCarousel_item"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ItemTileCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFavoriteItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "d52c4bd19a423eb1e8c31eb66b715209";

export default node;
